import customFetch from "../helpers/axios";

export async function getOrganizationSubscription(organizationId) {
  try {
    const { data } = await customFetch.get(
      `/api/subscriptions/organization-stripe-subscriptions/${organizationId}/`
    );
    return data;
  } catch (e) {
    const status = e?.response?.status;
    if (status === 404) return null;
    throw e;
  }
}

export async function getSubscriptionProductsDropdown() {
  const res = await customFetch.get(
    "/api/subscriptions/subscription/dropdown/"
  );
  const data = res?.data;
  if (Array.isArray(data)) return data;
  return data?.results || [];
}

export async function createSubscriptionCheckout({ planStripeId, billingCycle = "monthly" }) {
  // Normalizamos el ciclo de facturación a los valores que entiende el backend
  // UI usa "monthly" / "yearly", mientras que la API trabaja con "month" / "year".
  const apiBillingCycle =
    billingCycle === "yearly"
      ? "year"
      : billingCycle === "monthly"
      ? "month"
      : billingCycle;

  const payload = {
    plan_stripe_id: planStripeId,
    billing_cycle: apiBillingCycle,
  };
  const res = await customFetch.post(
    "/api/subscriptions/checkout/create/",
    payload
  );
  return res?.data || {};
}

export async function changeOrganizationPlan({ organizationId, fromPriceId, toPriceId, allowProration = true }) {
  const payload = {
    from_price_id: fromPriceId,
    to_price_id: toPriceId,
    allow_proration: allowProration,
  };
  const { data } = await customFetch.put(
    `/api/subscriptions/organization-stripe-subscriptions/${organizationId}/`,
    payload
  );
  return { ...data };
}

export async function cancelOrganizationSubscription({ organizationId, cancellationReason }) {
  const payload = {
    cancellation_reason: cancellationReason,
  };
  const { data } = await customFetch.delete(
    `/api/subscriptions/organization-stripe-subscriptions/${organizationId}/`,
    { data: payload }
  );
  return data;
}

// Payment history with optional filters
// filters: { status, status_in, payment_date_from, payment_date_to, payment_date, amount_paid_min, amount_paid_max, organization_id, organization_name, subscription_name }
export async function getSubscriptionPaymentHistory(filters = {}) {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    params.append(key, String(value));
  });

  const query = params.toString();
  const url = query
    ? `/api/subscriptions/payment-history/?${query}`
    : "/api/subscriptions/payment-history/";

  const { data } = await customFetch.get(url);
  return data;
}

export async function getCreditPackagesDropdown() {
  const res = await customFetch.get(
    "/api/subscriptions/credit-packages/dropdown/"
  );
  const data = res?.data;
  if (Array.isArray(data)) return data;
  return data?.results || [];
}

export async function createCreditPackagesMultiCheckout(items) {
  const payload = { items };
  const res = await customFetch.post(
    "/api/subscriptions/credit-packages/",
    payload
  );
  return res?.data || {};
}

// List credit purchases/consumption for the current organization
// GET /api/subscriptions/credit-purchases/
export async function getCreditPurchases(params = {}) {
  const search = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    search.append(key, String(value));
  });

  const query = search.toString();
  const url = query
    ? `/api/subscriptions/credit-purchases/?${query}`
    : "/api/subscriptions/credit-purchases/";

  const res = await customFetch.get(url);
  return res?.data || {};
}
